import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Giunzione } from "../types"

export function useGiunzioniList(params: Record<string, string | string[] | number[] | number> = {}) {
  return useList<Giunzione>(`${API_URL}/giunzioni`, { query: params })
}
